import { TreeDataProvider } from '@/logic/treeData'
import React, { useContext } from 'react'

export const TreeDataContext = React.createContext<TreeDataProvider>(undefined!)

export function useNodeData(id: number) {
  return useContext(TreeDataContext).node(id)
}

export type FocusAction = {
  nodes: number[]
  center?: boolean
}
